import Record from './Record'

export default class Issue extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			return new Issue({
				id: null,
				responsible_user_id: Anvil?.session?.user?.id || null,

				link: null,
				company_id: null,
				company_db_id: null,
				site_id: null,
				terminal_id: null,
				aee_id: null,

				closed: false,

				title: '',
				description: '',
				tags: [],
				priority_tag: null,
				work_tags: [],

				notes: []
			})
		} else {
			// Load
			let data = await Anvil.REST.get(`/issue/${id}`)

			return new Issue(data)
		}
	}

	static async delete (id) {
		await Anvil.REST.delete(`/issue/${id}`)
	}

	async commit () {
		if (this._data.id == null) {
			// Insert
			const res = await Anvil.REST.post(`/issue`, this._data)
			this._data.id = res.insertId
		} else {
			// Update
			await Anvil.REST.put(`/issue/${this._data.id}`, this._data)
		}
	}

	async refetch () {
		if (this._data.id != null) {
			const fresh = await Issue.fetch(this._data.id)
			Object.assign(this._data, fresh.record._data)
		}
	}

	// Additional methods can be added here

	async addComment (comment) {

		// Insert comment
		const res = await Anvil.REST.post(`/issue/${this._data.id}/comment`, {
			description: comment,
			insert_user_id: Anvil.session.user.id
		})

		// Refresh issue data (including comments)
		await this.refetch()
	}

	async editComment (id, comment) {

		// Update comment
		const res = await Anvil.REST.put(`/issue/${this._data.id}/comment/${id}`, {
			description: comment,
			update_user_id: Anvil.session.user.id
		})

		// Refresh issue data (including comments)
		await this.refetch()
	}
}
